import { z } from 'zod/v4-mini';

import { backendEndpoints } from '$/services/endpoints';
import { fetcher } from '$/services/fetcher';
import { GeneralBackendResponseSchema } from '$/services/mapper/authentication';

export const GeolocationSchema = z.object({
  ...GeneralBackendResponseSchema,
  payload: z.object({
    countryRegion: z.optional(z.object({ isoCode: z.nullable(z.string()) })),
    ipAddress: z.string(),
  }),
});

export const getGeolocation = async () => {
  return fetcher(backendEndpoints.GEOLOCATION_URL, {
    method: 'GET',
    parser: (data) => GeolocationSchema.parse(data),
  });
};
